import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
import moment from "moment";
import { useQuery } from "@apollo/client";
//Import from project
import "../../Style/pagestyle.scss";
import { padStartINV } from "../../Function/DynamicFn";
import { currencyFormat } from "../../Function/DynamicFn";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import FooterPagination from "../Include/FooterPagination";
import { GET_TOBE_PAID_NOTIFICATION_PAGINATION } from "../../Schema/ToPayInvoice";
import SentToPayInvoiceAction from "./SentToPayInvoiceAction"

export default function SentToPayInvoiceDetails(
  {
    page,
    setPage,
    keyword,
    fromDate,
    toDate,
    academicYearId,
    paymentType
  }
) {

  const [limit, setLimit] = useState(8);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  let pageStudent = window.localStorage.getItem("pageStudent");

  // console.log("eee::", page, limit, keyword, academicYearId)

  const { refetch } = useQuery(GET_TOBE_PAID_NOTIFICATION_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      academicYearId: academicYearId,
      fromDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : null,
      toDate: toDate ? moment(toDate)?.format("YYYY-MM-DD") : null,
      typeOfPayment: paymentType
    },
    onCompleted: ({ getToBePaidNotificationWithPagination }) => {
      setLoading(false);
      // console.log("getToBePaidNotificationWithPagination::", getToBePaidNotificationWithPagination)
      if (getToBePaidNotificationWithPagination?.data?.length > 0) {
        setTableData(getToBePaidNotificationWithPagination?.data);
        setPaginationData(getToBePaidNotificationWithPagination?.paginator);
      } else {
        setTableData([]);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, fromDate, toDate, academicYearId, paymentType]);

  useEffect(() => {
    if (pageStudent) {
      setPage(parseInt(pageStudent));
    } else {
      setPage(1);
    }
  }, [pageStudent]);

  // =========================== Resize width Screen ==================================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // =========================== Ebd Resize width Screen ==============================

  return (
    <div className="page-container">
      <Box className="body-container">

        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell className="header-title-start">N°</TableCell>
                <TableCell className="header-title">StudentID</TableCell>
                <TableCell className="header-title">
                  InvoiceID
                </TableCell>
                <TableCell className="header-title">
                  To pay date
                </TableCell>
                <TableCell className="header-title">Full Name</TableCell>
                <TableCell className="header-title">
                  English name
                </TableCell>
                <TableCell className="header-title">Class</TableCell>
                <TableCell className="header-title">Payment type</TableCell>
                <TableCell className="header-title">Amount</TableCell>
                <TableCell className="header-title">Show mobile</TableCell>
                <TableCell className="header-title">Is Seen</TableCell>
                <TableCell className="header-title-end"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={15} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={15} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody
                    className="body"
                  >
                    {tableData?.map((row, index) => {
                      console.log("row::", row)
                      return (
                        <TableRow
                          className="body-row"
                          key={index}
                        >
                          <TableCell
                            className="body-cell-start"
                          >
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {row?.studentId}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {padStartINV(row?.invoiceId)}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {moment(row?.dateToBePaid).format("DD-MMM-YYYY")}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {row?.lastName + " " + row?.firstName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {row?.englishName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {row?.gradeName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            {row?.incomeType}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            $ {currencyFormat(row?.estimateAmount)}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            <Box
                              sx={{
                                padding: "2px 10px",
                                width: "65px",
                                borderRadius: "12px",
                                fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: row?.isShowMobileApp ? "#0f81c2 !important" : "#ff0000 !important",
                                color: "#fff",
                                textAlign: "center"
                              }}
                            >
                              {row?.isShowMobileApp ? "Yes" : "No"}
                            </Box>

                          </TableCell>
                          <TableCell
                            className="body-cell"
                          >
                            <Box
                              sx={{
                                padding: "2px 10px",
                                width: "65px",
                                borderRadius: "12px",
                                fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: row?.isSeen ? "#0f81c2 !important" : "#ff0000 !important",
                                color: "#fff",
                                textAlign: "center"
                              }}
                            >
                              {row?.isSeen ? "Yes" : "No"}
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end">
                            <SentToPayInvoiceAction editData={row} setRefetch={refetch} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* =============================== Pagination =============================== */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
